const useGetAllRoleOfUser = (profileUser) => profileUser.roles.data.map((item) => item.id);

export default useGetAllRoleOfUser;
